import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";

const GridSkeleton = ({ rows = 0, cols = 0 }) => {
	return (
		<Grid container spacing={1}>
			{Array.from({ length: rows * cols }, (_, index) => (
				<Grid xs={12 / cols} item key={index} data-testid="skeleton">
					<Skeleton />
				</Grid>
			))}
		</Grid>
	);
};

export default GridSkeleton;
